import { AppRouter } from "@/app/router";

/**
 * Root component i SPA-se.
 */
export const App = (): JSX.Element => <AppRouter />;
